import { TableHeader as TableHeaderToExtend } from '@tiptap/extension-table-header';

export const TableHeader = TableHeaderToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: {
                default: null
            }
        }
    }
})
